@layer ch-tabular-grid {
  ch-tabular-grid:has(ch-tabular-grid-virtual-scroller)::part(main) {
    grid-template-rows: max-content var(
        --ch-tabular-grid-virtual-scroller-height
      );
  }

  ch-tabular-grid-virtual-scroller {
    display: grid;
    height: max-content;

    position: sticky;
    top: 0px;

    grid-auto-rows: max-content;
    grid-column: 1 / -1;
    grid-row: 2;
    grid-template-columns: subgrid;
  }
}
